module.exports = __webpack_public_path__ + "img/social-google.5c3ca30.svg";